import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import AppImageDetail from '../general-details/AppImageDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import FormOtherPIC from 'src/components/form/general-input-form/FormOtherPic'
import FormClientAdditionalAddress from 'src/components/form/general-input-form/FormClientAdditionalAddress'

// helper
import { getFileType } from 'src/helpers/get-file-type'

const AppDetails = ({
  clientDetails,
  handleViewFile
}) => {
    let files = []
    let fileType = ''
    if (clientDetails?.npwp_original_name) {
      fileType = getFileType(clientDetails?.npwp_original_name)
      files = [
        {
          file_url: clientDetails?.npwp_url,
          file_original_name: clientDetails?.npwp_original_name
        }
      ]
    }
  return (
    <>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Client Name"
          subtitle={clientDetails?.name ? clientDetails?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Name"
          subtitle={clientDetails?.pic_name ? clientDetails?.pic_name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Contact Number"
          subtitle={clientDetails?.country_phone?.phone_code ? `${clientDetails?.country_phone?.phone_code}${clientDetails?.pic_contact_number}`: '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Job Position"
          subtitle={clientDetails?.pic_job_position ? clientDetails?.pic_job_position : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Email Address"
          subtitle={clientDetails?.pic_email_address ? clientDetails?.pic_email_address : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Department/Division"
          subtitle={clientDetails?.pic_department ? clientDetails?.pic_department : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Main Point of Contact (PoC) Additional Notes"
          subtitle={clientDetails?.pic_additional_notes ? clientDetails?.pic_additional_notes : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        <AppTextColumnDetails
          colSize="3"
          title="Client Description"
          className={'mb-2'}
          subtitle={clientDetails?.description ? clientDetails?.description : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client Address"
          className={'mb-2'}
          subtitle={clientDetails?.address ? clientDetails?.address : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client Country"
          className={'mb-2'}
          subtitle={clientDetails?.country ? clientDetails?.country?.name : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client Province"
          className={'mb-2'}
          subtitle={clientDetails?.province ? clientDetails?.province?.label ? clientDetails?.province?.label : '-' : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client City"
          className={'mb-2'}
          subtitle={clientDetails?.city ? clientDetails?.city?.label ? clientDetails?.city?.label : '-' : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client District"
          className={'mb-2'}
          subtitle={clientDetails?.district ? clientDetails?.district?.label ? clientDetails?.district?.label : '-' : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client Sub District"
          className={'mb-2'}
          subtitle={clientDetails?.subdistrict ? clientDetails?.subdistrict?.label ? clientDetails?.subdistrict?.label : '-' : '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          title="Client Postal Code"
          className={'mb-2'}
          subtitle={clientDetails?.postal_code ? clientDetails?.postal_code : '-'}
        />
      </CRow>
      <CRow className='mb-4'>
        {
          fileType === 'image' ? (
            <AppImageDetail
              colSize="6"
              title="Document NPWP"
              images={clientDetails?.npwp_url}
              handleViewFile={handleViewFile}
            />
          ) : (
            <CCol lg={6}>
              <CFormLabel>
                Document NPWP
              </CFormLabel>
              <FormFileThumbnail 
                name='npwp_image'
                colSize='6'
                files={files}
                className='justify-content-start align-items-center'
                handleViewFile={handleViewFile}
                isDetailPage={true}
              />
            </CCol>
          )
        }
      </CRow>
      <CRow>
        <FormOtherPIC 
          inputLabel={'Other Point of Contact (PoC)'}
          className={'mb-3'}
          othersPIC={clientDetails?.others_pic}
          isDetail={true}
          disabled={true}
        />
      </CRow>
      <CRow>
        <FormClientAdditionalAddress 
          inputLabel={'Additional Client Address'}
          className={'mb-3'}
          additional_address={clientDetails?.additional_address}
          isDetail={true}
          disabled={true}
        />
      </CRow>
    </>
  )
}

export default AppDetails
